import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import store from './store/store';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { preloadPayDayImages } from './preloadPayDayImages.js';
import ACTION_TYPES from '../src/store/actionTypes.constants';

interface AppProps {
  children: object;
}

function PreloadManager() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: ACTION_TYPES.IMAGES_LAODING, payload: true });

    preloadPayDayImages()
      .then(() => {
        dispatch({ type: ACTION_TYPES.IMAGES_LAODING, payload: false });
      })
      .catch(() => {
        dispatch({ type: ACTION_TYPES.IMAGES_LAODING, payload: false });
      });
  }, [dispatch]);

  return null; // doesn’t render anything, just runs logic
}

function AppWrapper(props: AppProps) {
  const queryClient = new QueryClient();
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PreloadManager />
        {props.children}
      </QueryClientProvider>
    </Provider>
  );
}

export default AppWrapper;
